import { fullBasePath } from "../../util/util"
import Nav from 'react-bootstrap/Nav'
import {useState } from 'react'
import "./topNav.css"

const TopNavPublic = props => {

    let url = window.location.href;
    let trainerPage = url.split('/')[3];

    let trainerLink = false;

    // show reduced menu if its a blog page
    if (url.includes("blog")) {
        trainerLink = true;
    }


    const [showMobileMenu, setShowMobileMenu] = useState(false);


    return (
        trainerLink ?
            <Nav style={{ background: "#000d2d" }}>
                <div className="py-4" >
                    <img
                        className="d-block ml-5"
                        src={
                            "https://cdn.fitsw.com/assets/img/brand/FitSW-Personal-Trainer-Software-Logo-For-Fitness-Coaches.png"
                        }
                        alt="logo"
                    />

                </div>
                <a className="nav-link text-white my-auto bg-primary ml-auto mr-3" style={{ borderRadius: "5px" }} href={`${fullBasePath()}/${trainerPage}`}>
                    Trainer Page
                </a>
                <a className="nav-link text-white my-auto mr-5" style={{ borderRadius: "5px" }} href={`${fullBasePath()}/signin`}>
                    Sign In
                </a>
            </Nav>
            :

            <div className="topNavPublicContainerBox">


                <div id="navbar" className="menu-container" >
                    <div className="menu-content d-flex" >
                        <div className="menu-left">
                            <a href="/" aria-current="page">
                                <img src='https://cdn.fitsw.com/assets/img/brand/FitSW-Personal-Trainer-Software-Logo-For-Fitness-Coaches.png' alt="fitsw logo" className="nav-logo" style={{ maxWidth: "9999px", width: "auto", height: "auto" }} width='122' height='47' /></a>
                        </div>
                        <div className={`mobile-menu`}>
                            <button onClick={(e) => { setShowMobileMenu((prev) => !prev) }} className="menubtn">&#9776;</button>
                            <div id="mobile-dropdown" className={`dropdown-content ${showMobileMenu ? "show" : null} `}>
                                <a href="/pricing/" >Pricing</a>
                                <a id='custom-app-link' href="/custom-branded-apps/">Custom Apps</a>
                                <a href="/">Trainers</a>
                                <a href="/studios">Studios</a>
                                <a href="/enterprise">Enterprise</a>
                                <a href="https://www.fitsw.com/blog/">Updates &amp; Insights</a>
                                <a href="https://www.fitsw.com/help/for-trainers/">Help Center</a>
                                <a href="/faq/">FAQ</a>
                                <a href="/personal-trainer-online-tools/">Personal Trainer Online Tools</a>
                                <a href="/signin/">Sign In</a>
                                <a id='try-for-free' href="/signup/">Try FitSW for Free</a>
                            </div>
                        </div>

                        <div className="menu-links w-100" >
                            <div className="nav-dropdown">
                                <button className="dropbtn">Product</button>
                                <div className="dropdown-content">
                                    <a href="/features/"><img src="https://cdn.fitsw.com/external-site/images/App-For-Personal-Trainers-Features-Icon.svg" alt="App For Personal Trainers Features Icon" className="feature-icon" width="26" height="26" />Features</a>
                                    <a href="/custom-branded-apps/"><img src="https://cdn.fitsw.com/external-site/images/Custom-Fitness-App-Icon.svg" alt="Custom Fitness App Icon" className="feature-icon" width="26" height="26" />Custom Apps</a>
                                </div>
                            </div>
                            <a id="pricing-link" className="dropbtn" href="/pricing/" > Pricing</a>
                            <div className="nav-dropdown">
                                <button className="dropbtn">Resources</button>
                                <div id="resource-dropdown" className="dropdown-content">
                                    <div className="resource-column">
                                        <a href="https://www.fitsw.com/help/"><img src="https://cdn.fitsw.com/external-site/images/App-For-Trainers-Help-Center-Icon.svg" alt="App for personal trainers help center icon." className="feature-icon" width="26" height="26" />Help Center</a>
                                        <a href="https://www.fitsw.com/blog/"><img src="https://cdn.fitsw.com/external-site/images/Personal-Trainer-Blog-Icon.svg" alt="Personal Trainer Blog Icon" className="feature-icon" width="26" height="26" />Insights & Updates</a>
                                    </div>
                                    <div className="resource-column">
                                        <a href="/faq/"><img src="https://cdn.fitsw.com/external-site/images/Personal-Trainer-Software-FAQs.svg" alt="Personal Trainer Software FAQ" className="feature-icon" width="26" height="26" />FAQ</a>
                                        <a href="/personal-trainer-online-tools/"><img src="https://cdn.fitsw.com/external-site/images/Personal-Trainer-Guide.svg" alt="Personal Trainer Online Tools" className="feature-icon" width="26" height="26"></img>Personal Trainer Online Tools</a>
                                    </div>
                                </div>
                            </div>
                            <a id="studio-link" className="dropbtn" href="/studios"> Studios</a>
                            <a id="enterprise-link" className="dropbtn" href="/enterprise"> Enterprise</a>
                            <a className="dropbtn sign-button" id="signup" href="/signup/" style={{ float: "right", backgroundColor: "white", color: "black", marginLeft: "10px", borderRadius: "6px" }}> Try it free</a>
                            <a id="signin-link" className="dropbtn sign-button" href="/signin/" style={{ float: "right", backgroundColor: "hsla(0,0%,100%,.05)", borderRadius: "6px" }}> Sign in</a>
                        </div>
                    </div>
                </div>
            </div>
    )
}

export default TopNavPublic